export const state = {
    users: [],
}; 